import { ZRoleFields } from "../../RolesTab.types";

export type EdRoleObject = Omit<ZRoleFields, "defaultPermissions"> & {
  defaultPermissions?: ZRoleFields["defaultPermissions"][];
};

export const edit2RoleObject = (values: EdRoleObject) => ({
  ...values,
  defaultPermissions: values.defaultPermissions?.flat().filter(Boolean),
});
